import React from 'react'

import { Notice } from '@shared/components/Notice'

import { usePageNotice } from './PageNoticeContext'

export const PageNoticeContainer: React.FC = () => {
  const { notices } = usePageNotice()

  if (notices.length === 0) {
    return null
  }

  return (
    <div>
      {notices.map((notice) => (
        <Notice key={notice.id} {...notice} />
      ))}
    </div>
  )
}
